// import React from 'react'

const accountingClass = {
  businessid: { type: 'string', title: 'Y-tunnus' },
  taxbase: {
    type: 'number',
    title: 'Alv verokanta',
    oneOf: [
      { const: 0, title: '0 %' },
      { const: 10, title: '10 %' },
      { const: 13.5, title: '13,5 %' },
      { const: 14, title: '14 %' },
      { const: 24, title: '24 %' },
      { const: 25.5, title: '25,5 %' },
    ],
  }
}

export const _partnerClass = {
  displayName: { type: 'string', title: 'Nimi' },
  type: {
    type: 'string',
    title: 'Partnerityyppi',
    oneOf: [
      { const: 'seura', title: 'Seura' },
      { const: 'yritys', title: 'Yritys' },
    ],
  },
  ...accountingClass,

}

export const _partnerClassDeps = {}

export const _partnerUISchema = {
    vat: {
    'ui:enumDisabled': [10, 14, 24],
  },
}
